import request from '@/utils/request'
import { ContentTypeJson, ContentTypeForm } from '@/utils/content-type'

// 普通用户登录
export function login(data) {
    return request({
        url: '/user/login',
        method: 'post',
        ...ContentTypeJson(data)
        // ...ContentTypeForm(data)
    })
}

// 企业用户登录
export function enterpriseLogin(data) {
    return request({
        url: '/enterprise/user/login',
        method: 'post',
        ...ContentTypeJson(data)
    })
}

// 退出登录
export function logout() {
    return request({
        url: '/logout',
        method: 'post'
    })
}

// 获取用户信息
export function getInfo() {
    return request({
        url: '/enterprise/user/getUserDetailedInfo',
        method: 'get',
    })
}

// 获取项目环境
export function getEnvironment() {
    return request({
        url: '/config.json',
        method: 'get',
    })
}


/* export function getEnvironment() {
    return request({
        url: '/user/getEnvironment',
        method: 'get',
    })
} */